import { LoadingProgress } from 'utils/sagas/uploading';
import { Task } from 'redux-saga';
import { call, cancel, delay, put } from 'redux-saga/effects';
import { isSameTaskId, isSceneExists } from 'utils/sagas/scenes';
import { setSceneCreationProgress } from 'modules/scenesCreationProgress';
import { setScenesDownloadingProgress } from 'modules/sceneDownloadingProgress';
import { saveRevision } from 'modules/revisions';
import { ToolName } from 'types/AppState';

export function* handleSceneUploadingProgress(
  needsProcessing: boolean,
  progress: LoadingProgress,
  sceneId: string,
  uploadTaskId: string,
  uploadTask: Task
) {
  const steps = needsProcessing ? 3 : 1;

  while (!progress.errorHappened && !progress.taskDone) {
    const sceneExists: boolean = yield call(isSceneExists, sceneId);
    const sameUploadTask: boolean = yield call(isSameTaskId, sceneId, uploadTaskId);

    if (!sceneExists || !sameUploadTask) {
      yield cancel(uploadTask);
      yield cancel();
    }

    const totalProgress =
      (progress.uploading + progress.downloading + progress.preprocessing) / steps;

    yield put(setSceneCreationProgress(totalProgress, sceneId));
    yield delay(100);
  }

  if (!progress.errorHappened) {
    yield put(setSceneCreationProgress(100, sceneId));
  }
}

export function* handlePhotoSidebarProgress(
  progress: LoadingProgress,
  sceneId: string,
  uploadTaskId: string,
  taskToCancel: Task
) {
  yield put(setScenesDownloadingProgress(0, sceneId));
  while (!progress.taskDone && !progress.errorHappened) {
    const sceneExists: boolean = yield call(isSceneExists, sceneId);
    const sameTaskId: boolean = yield call(isSameTaskId, sceneId, uploadTaskId);

    if (!sceneExists || !sameTaskId) {
      yield cancel(taskToCancel);
      yield cancel();
    }

    yield put(setScenesDownloadingProgress(progress.downloading, sceneId));
    yield delay(100);
  }

  yield put(setScenesDownloadingProgress(100, sceneId));
  yield put(saveRevision(ToolName.Photo));
}
